import Vue from 'vue';

const userModule = {
  namespaced: true,

  state: {
    b2bUnit: {},
    loggedIn: window.ACC.userLoggedIn || false,
  },

  mutations: {
    setB2bUnit(state, value) {
      Vue.set(state, 'b2bUnit', value);
    },
  },
};

export default userModule;
